import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CartoucheLivraisonItem, CartouchesService } from '../../../services/cartouches.service';

@Component({
  selector: 'app-cartouches-en-cours-livraison',
  imports: [CommonModule, RouterLink],
  templateUrl: './cartouches-en-cours-livraison.component.html',
  styleUrl: './cartouches-en-cours-livraison.component.scss'
})
export class CartouchesEnCoursLivraisonComponent implements OnInit {
  protected loading = false;
  protected error = '';
  protected items: CartoucheLivraisonItem[] = [];

  constructor(
    private readonly cartouchesService: CartouchesService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.load();
  }

  protected refresh(): void {
    this.load();
  }

  private load(): void {
    this.loading = true;
    this.error = '';
    this.cdr.markForCheck();

    this.cartouchesService.listLivraisonsFields().subscribe({
      next: (items: CartoucheLivraisonItem[]) => {
        this.items = items.filter((item) => this.isEnCours(item.statut_livraison_nom));
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: (err: HttpErrorResponse) => {
        this.items = [];
        this.error = this.getErrorMessage(err);
        this.loading = false;
        this.cdr.markForCheck();
      }
    });
  }

  private isEnCours(value: string | null): boolean {
    return String(value ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase() === 'en cours de transit';
  }

  private getErrorMessage(err: HttpErrorResponse): string {
    if (typeof err.error === 'string' && err.error.trim()) {
      return err.error;
    }
    if (err.error?.detail) {
      return String(err.error.detail);
    }
    if (err.error?.message) {
      return String(err.error.message);
    }
    return err.statusText || 'Erreur inconnue';
  }
}
